function AccountMerging(){
     return(
           <div>  
             <h2> AccountMerging</h2>
             <p>details here</p>
            </div>
         );
}
export default AccountMerging;